module.exports = __webpack_public_path__ + "media/images/bnr-early-lg-e49e9167cd8aa0e6b74aa310ed5f5d29.png";